import { render, staticRenderFns } from "./rental-request-view.vue?vue&type=template&id=8c0891cc&"
import script from "./rental-request-view.vue?vue&type=script&lang=js&"
export * from "./rental-request-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports